module.exports = __webpack_public_path__ + "static/media/In_Depth_Hero_Tablet.c7a364c3.png";